<template>
    <frontend-layout>
        <template #page_header>
            <div
                class="w-full bg-gray-900 px-4 py-8 text-center text-white md:py-16"
            >
                <h1 class="mb-4 text-[28px] font-bold md:text-[40px]">
                    Frequently Asked Questions
                </h1>
                <div class="">
                    If you have additional questions that you don’t see below,
                    send us an email at
                    <a class="link link-on-dark" href="mailto:info@emtprep.com"
                        >info@emtprep.com</a
                    >
                </div>
            </div>
        </template>

        <div class="container max-w-screen-lg px-4 pt-8 md:px-0 md:pt-16">
            <div
                class="flex flex-col items-start md:flex-row md:justify-between"
                v-for="(groupedFaqQuestions, groupName) in faqQuestions"
            >
                <div class="my-4 w-96 flex-none text-[34px] font-semibold">
                    {{ groupName }}
                </div>
                <div class="mb-8 flex-grow md:mb-16">
                    <expanding-text-block
                        v-for="faqQuestion in groupedFaqQuestions"
                        :question="faqQuestion.question"
                        :answer="faqQuestion.answer"
                    />
                </div>
            </div>
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import ExpandingTextBlock from "@/Components/ExpandingTextBlock";

export default {
    name: "Faqs",
    components: { FrontendLayout, ExpandingTextBlock },
    props: {
        faqQuestions: {
            type: Array,
            default: [],
        },
    },
};
</script>

<style scoped></style>
